import { render, staticRenderFns } from "./Register_HeNan.vue?vue&type=template&id=90537fc8&scoped=true&"
import script from "./Register_HeNan.vue?vue&type=script&lang=js&"
export * from "./Register_HeNan.vue?vue&type=script&lang=js&"
import style0 from "./Register_HeNan.vue?vue&type=style&index=0&id=90537fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90537fc8",
  null
  
)

export default component.exports